/*
* router路由
* */
// import Vue  from "vue"
import store from '@/store'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {informationIndexModule, informationInfo} from '@/api/getData'
import { checkPower } from '@/utils/checkPower'
// 引入菜单json数据
import navMenuJson from '@/json/navMenuJson'

Vue.use(VueRouter)

// 定义main主目录的子级路由数组
let mainRoutes = []
// 加入路由数据方法
let addRoutes = (item, parent) => {
  mainRoutes.push({
    path: item.value,
    name: item.name,
    component: () => import('@/pages' + item.value),
    children: [],
    meta: {
      'title': item.alias,
      parentPower: parent && parent.entity.power,
      power: item.power,
      ...item.meta
    }
  })
}
// 循环菜单json数据添加路由 目前菜单只会有两层
for (let item of navMenuJson.data) {
  let entity = item.entity
  if (item.entity.value) {
    addRoutes(item.entity)
  }
  for (let childs of item.childs) {
    if (childs.entity.value) {
      addRoutes(childs.entity, item)
    }
  }
}

let routes = [
  {
    path: '*',
    component: () => import('@/components/error')
  },
  {
    path: '/',
    redirect: '/information/index'
  },
  {
    path: '/test',
    component: () => import('@/pages/home/test')
  },

  {
    path: '/main',
    component: () => import('@/pages/main'),
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/pages/information/index')
      },
      {
        path: '/home/busnessStatus',
        name: 'home/busnessStatus',
        component: () => import('@/pages/home/busnessStatus')
      },
      {
        path: '/home/warn',
        component: () => import('@/pages/home/warn')
      },
      {
        path: '/bills/flow',
        component: () => import('@/pages/bills/flow')
      },
      ...mainRoutes]
  }
]

// 判断是否生产环境，生产环境的根目录设置为busness
function getAbsolutePath () {
  if (process.env.NODE_ENV == 'development') {
    var base = ''
  } else {
    var base = '/busness/'
  }
  return base
}

const _router = new VueRouter({
  // base:"/busness/",
  base: getAbsolutePath(),
  mode: 'history',
  routes
})
/** 路由前置
 * 获取企业信息判断是否已经审核了企业信息，否则不能使用功能
 * */
_router.beforeEach((to, from, next) => {
  NProgress.start()// 调用进度条
  // 如果url里有传值token，则是从后台系统跳转过来，需要去获取企业信息
  if (to.query.token) {
    store.commit('SET_TOKEN', to.query.token)// 设置token缓存值
    var getBusness = new Promise(resolve => {
      // 获取企业账户信息
      informationInfo.get({
        success: function (data) {
          // 账户信息缓存起来
          store.commit('SET_USERMESSAGE', data)
          resolve()
        }
      })
    })
    getBusness.then(() => routerLink(to, next))
  } else {
    routerLink(to, next)
  }

  // 跳转方法
  function routerLink (to, next) {
    const {parentPower, power} = to.meta
    if ((parentPower && !checkPower(parentPower)) || !checkPower(power)) return next('/404')
    // 如果需要校验
    if (to.meta.checkBusness) {
      // 获取缓存的企业信息
      var busnessInfo = store.state.userModule.busnessInfo
      // 如果设置了企业信息，则是已经获取了，此时判断是否审核通过
      if (busnessInfo) {
        // 审核通过了则通过校验
        if (busnessInfo.audit_status == 1) {
          next()
        } else {
          next({path: '/home/warn'})
        }
      } else {
        // 如果没有设置企业信息，则是需要获取企业信息
        informationIndexModule.get({
          success: function (data) {
            // 缓存起来
            store.commit('SET_BUSINESS_INFO', data)
            // 判断是否已填写企业信息，且已审核通过，否则前往填写企业信息页面
            if (data && data.audit_status == 1) {
              next()
            } else {
              next({path: '/home/warn'})
            }
          }
        })
      }
    } else {
      next()
    }
  }
})
_router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

export default _router



// WEBPACK FOOTER //
// ./src/router/index.js